module.exports = __webpack_public_path__ + "static/marazzi-406c79cfb00efd5a47323265abc56d6d.png";